<template>
  <el-dialog
    :visible="visible"
    width="630px"
    custom-class="strategy-risk-confirm"
    append-to-body
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    @closed="$emit('closed')"
  >
    <div class="strategy-risk-confirm__head">
      <h2>{{ dialogTitle }}</h2>
      <button type="button" aria-label="关闭风险提示" @click="close">
        <i class="el-icon-close" aria-hidden="true" />
      </button>
    </div>

    <ul class="strategy-risk-confirm__list">
      <li>
        使用智能合约交易是复杂且有风险的。 您在交易合约时可能会实现大幅收益或损失，
        因此在开始交易前请做好充分准备。 小幅价格波动也可能对您的交易产生很大的影响。
      </li>
      <li>
        当UPlus账户燃料费低于-10U时，智能合约交易将自动关闭，届时会产生较高风险。
      </li>
      <li>
        请务必在开始交易前仔细阅读《UPlus智能量化交易协议》。
      </li>
      <li class="is-danger">
        极端情况可能会出现止损失效或爆仓情况，比如自己动资金/订单、交易所卡顿、拔网线、
        极端行情（黑天鹅）。
      </li>
      <li class="is-danger">
        服务器或程序故障、覆盖范围不足等不可控风险造成的经济损失，全部由用户自行承担。
      </li>
      <li class="is-danger">
        UPlus对您的任何交易概不负责，包括但不限于担保或赔偿。点击“确认”即表示您同意这些条款。
      </li>
    </ul>

    <div class="strategy-risk-confirm__accept">
      <label class="strategy-risk-confirm__checkbox" for="strategy-risk-accepted">
        <input
          id="strategy-risk-accepted"
          v-model="accepted"
          type="checkbox"
          aria-label="同意UPlus智能量化交易协议"
        />
        <span aria-hidden="true">
          <i class="el-icon-check" />
        </span>
      </label>
      <span>
        <label for="strategy-risk-accepted">我已阅读和了解相关协定，并已知晓风险</label>
        <button type="button" @click="$emit('agreement')">
          点击查看《UPlus智能量化交易协议》
        </button>
      </span>
    </div>

    <div class="strategy-risk-confirm__actions">
      <button
        class="is-confirm"
        :class="{ 'is-waiting': !accepted }"
        type="button"
        :aria-disabled="accepted ? 'false' : 'true'"
        @click="confirm"
      >
        进入交易
      </button>
      <button class="is-leave" type="button" @click="close">暂不交易，离开</button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'StrategyRiskConfirmModal',
  props: {
    visible: { type: Boolean, default: false },
    product: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      accepted: false
    }
  },
  computed: {
    dialogTitle() {
      const kind = this.product.kind
      const key = this.product.key || ''
      if (kind === 'term') return 'UPlus期现AI交易风险提示'
      if (kind === 'bb') return 'UPlus BB双向AI交易风险提示'
      if (kind === 'grid') return 'UPlus现货网格交易风险提示'
      if (kind === 'martin') return 'UPlus现货马丁交易风险提示'
      if (kind === 'vip' || key.indexOf('futures-x') === 0) {
        return 'UPlus-X AI合约交易风险提示'
      }
      return 'UPlus智能合约交易风险提示'
    }
  },
  watch: {
    visible(value) {
      if (value) this.accepted = false
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    confirm() {
      if (!this.accepted) {
        this.$message.warning('请先认真阅读并确认勾选《UPlus智能量化交易协议》')
        return
      }
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>
.strategy-risk-confirm__head {
  position: relative;
  min-height: 32px;
  padding: 0 42px;
}

.strategy-risk-confirm__head h2 {
  margin: 0;
  color: rgba(0, 0, 0, .85);
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 32px;
}

.strategy-risk-confirm__head button {
  position: absolute;
  top: 0;
  right: 0;
  display: grid;
  width: 32px;
  height: 32px;
  padding: 0;
  place-items: center;
  color: #909399;
  border: 0;
  border-radius: 8px;
  background: transparent;
  font-size: 16px;
  cursor: pointer;
}

.strategy-risk-confirm__head button:hover {
  color: #1f6bff;
  background: #f4f7fc;
}

.strategy-risk-confirm__list {
  max-height: min(400px, 52vh);
  margin: 20px 0 0;
  padding: 0 4px 0 27px;
  overflow-y: auto;
  color: #3a3f4e;
  font-size: 14px;
  line-height: 22px;
}

.strategy-risk-confirm__list li {
  list-style: disc;
}

.strategy-risk-confirm__list li + li {
  margin-top: 7px;
}

.strategy-risk-confirm__list .is-danger {
  color: #e12020;
}

.strategy-risk-confirm__list::-webkit-scrollbar {
  width: 5px;
}

.strategy-risk-confirm__list::-webkit-scrollbar-thumb {
  border-radius: 99px;
  background: #d8dce5;
}

.strategy-risk-confirm__accept {
  display: flex;
  margin-top: 20px;
  align-items: flex-start;
  color: #3a3f4e;
  font-size: 14px;
  line-height: 22px;
}

.strategy-risk-confirm__checkbox {
  position: relative;
  display: inline-flex;
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  margin-top: 2px;
  cursor: pointer;
}

.strategy-risk-confirm__checkbox input {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  clip-path: inset(50%);
}

.strategy-risk-confirm__checkbox > span {
  display: grid;
  width: 18px;
  height: 18px;
  place-items: center;
  color: transparent;
  border: 1px solid #b8bfcc;
  border-radius: 4px;
  background: #fff;
  box-sizing: border-box;
  font-size: 12px;
  transition: border-color .16s ease, background .16s ease, box-shadow .16s ease;
}

.strategy-risk-confirm__checkbox:hover > span {
  border-color: #1f6bff;
}

.strategy-risk-confirm__checkbox input:focus-visible + span {
  box-shadow: 0 0 0 3px rgba(31, 107, 255, .16);
}

.strategy-risk-confirm__checkbox input:checked + span {
  color: #fff;
  border-color: #1f6bff;
  background: #1f6bff;
}

.strategy-risk-confirm__accept > span {
  margin-left: 10px;
}

.strategy-risk-confirm__accept > span > label {
  cursor: pointer;
}

.strategy-risk-confirm__accept button {
  padding: 0;
  color: #1f6bff;
  border: 0;
  border-bottom: 1px dashed #1f6bff;
  background: transparent;
  font: inherit;
  line-height: inherit;
  cursor: pointer;
}

.strategy-risk-confirm__actions {
  margin-top: 20px;
  text-align: center;
}

.strategy-risk-confirm__actions button {
  font-size: 14px;
  cursor: pointer;
}

.strategy-risk-confirm__actions .is-confirm {
  display: block;
  width: 80%;
  height: 42px;
  margin: 0 auto;
  color: #fff;
  border: 1px solid #1f6bff;
  border-radius: 8px;
  background: #1f6bff;
  font-size: 16px;
  font-weight: 700;
}

.strategy-risk-confirm__actions .is-confirm:hover {
  border-color: #1458da;
  background: #1458da;
}

.strategy-risk-confirm__actions .is-confirm.is-waiting {
  border-color: #8db1fa;
  background: #8db1fa;
}

.strategy-risk-confirm__actions .is-confirm.is-waiting:hover {
  border-color: #739ff5;
  background: #739ff5;
}

.strategy-risk-confirm__actions .is-leave {
  display: inline-block;
  margin: 10px auto 0;
  padding: 0;
  color: #1e2329;
  border: 0;
  border-bottom: 1px solid #1e2329;
  background: transparent;
}

@media (max-width: 680px) {
  .strategy-risk-confirm__head {
    padding: 0 34px;
  }

  .strategy-risk-confirm__actions .is-confirm {
    width: 100%;
  }
}
</style>

<style>
.strategy-risk-confirm {
  max-width: calc(100vw - 30px);
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(23, 31, 53, .2);
}

.strategy-risk-confirm .el-dialog__header,
.strategy-risk-confirm .el-dialog__footer {
  display: none;
}

.strategy-risk-confirm .el-dialog__body {
  padding: 24px 30px 20px;
}
</style>
